import {
  Box,
  ExpandableSection,
  SpaceBetween,
} from "@amzn/awsui-components-react";
import ReactJson from "react-json-view";
import { DigitalPaymentDocument } from "../../../types/documents";

interface DigitalPaymentDocumentViewProps {
  dpd: DigitalPaymentDocument;
  jsonViewProps: any;
}

export function DigitalPaymentDocumentView({
  dpd,
  jsonViewProps,
}: DigitalPaymentDocumentViewProps) {
  return (
    <SpaceBetween size="l">
      <ExpandableSection
        header={
          <Box variant="h4" margin={{ top: "xxs" }}>
            {dpd.id} (Digital Payment Document)
          </Box>
        }
        variant="container"
      >
        <ReactJson src={dpd.body} {...jsonViewProps} />
      </ExpandableSection>
    </SpaceBetween>
  );
}